export * from "./adapter"
export {default as ProfileNatural} from "./profile-natural-page.vue"
